export default {
  networkError: 'خطا در دریافت اطلاعات',
  filled: 'تکمیل شده',
  tryAgain: 'دوباره تلاش کن',
  noMatchFound: 'موردی یافت نشد',
  AI: 'ربات هوشمند',
  more: 'بیش تر',
  back: 'بازگشت',
};
